import { FC } from "react"
import styled from "styled-components"
import Color from "../../constants/Color"
import * as Animation from "../../functionality/Animation"

interface Props {
    widthInPx: number
}

const fontSize: Animation.VariableValue = {
    end: 20,
    start: 14,
    endControl: 800,    // Width in px
    startControl: 600,    // Width in px
}

const height: Animation.VariableValue = {
    end: 150,
    start: 100,
    endControl: 800,    // Width in px
    startControl: 400,    // Width in px
}

const Footer: FC<Props> = ({widthInPx}) => {

    const heightInPx = Animation.calculateValue(height, widthInPx)
    const fontSizeInPx = Animation.calculateValue(fontSize, widthInPx)

    return <Wrapper heightInPx={heightInPx} fontSizeInPx={fontSizeInPx}>
        We respect your privacy<br/>so this website uses<br/>no cookies
    </Wrapper>
}

export default Footer

const Wrapper = styled.div.attrs<{heightInPx: number, fontSizeInPx: number}>(p => ({
    style: {
        height: p.heightInPx + "px",
        fontSize: p.fontSizeInPx + "px",
    }
}))`
    background-color: ${Color.Black};

    display: flex;
    flex-direction: column;
    justify-content: center;

    color: ${Color.White};
    line-height: 1.5;
    text-align: center;
    letter-spacing: 0.05em;
    font-weight: 100;
`